import request from '@/utils/request';
import config from '@/config';

const { apiInfo } = config;
const mineUrl = `${apiInfo.mine.prefix}${apiInfo.mine.group}`;

export function getMineList(
    PlanName,
    ApproveStatus,
    CreateUserID,
    PlanType,
    PlanCountry,
    CreateMonthB,
    CreateMonthE,
    LastModifiedB,
    LastModifiedE,
    PlanOwnerUser,
    pageIndex,
    pageSize
) {
    const url =
        mineUrl +
        `/MineList?PlanName=${PlanName}&ApproveStatus=${ApproveStatus}&CreateUserID=${CreateUserID}&PlanType=${PlanType}&PlanCountry=${PlanCountry}&CreateMonthB=${CreateMonthB}&CreateMonthE=${CreateMonthE}&LastModifiedB=${LastModifiedB}&LastModifiedE=${LastModifiedE}&PlanOwnerUser=${PlanOwnerUser}&pageIndex=${pageIndex}&pageSize=${pageSize}`;

    return request({
        url: url,
        method: 'get'
    });
}

export function createPlan(planInfo) {
    const url = mineUrl + '/PlanCreate';

    return request({
        url: url,
        method: 'post',
        data: {
            ...planInfo
        }
    });
}

export function postPlan(planInfo) {
    const url = mineUrl + '/Plan';

    return request({
        url: url,
        method: 'put',
        data: {
            planID: planInfo.planID,
            planName: planInfo.planName,
            planType: planInfo.planType,
            fileID: planInfo.fileID,
            remarks: planInfo.remarks,
            planDate: planInfo.planDate,
            planDateEnd: planInfo.planDateEnd,
            planCountry: planInfo.planCountry,
            approveStatus: planInfo.approveStatus,
            approveUserID: planInfo.approveUserID,
            createUserID: planInfo.createUserID,
            createTime: planInfo.createTime,
            loadDecision: planInfo.loadDecision,
            duplicationFlag: planInfo.duplicationFlag,
            lastModifiedBy: planInfo.lastModifiedBy,
            lastModified: planInfo.lastModified,
            datFlag: planInfo.datFlag,
            planOwner: planInfo.planOwner,
            planOwnerUser: planInfo.planOwnerUser,
            sumVols: planInfo.sumVols,
            p2vols: planInfo.p2vols,
            p2volscannib: planInfo.p2volscannib,
            p2botdtc: planInfo.p2botdtc,
            p2botroi: planInfo.p2botroi,
            p2distribution: planInfo.p2distribution,
            p2ecommerce: planInfo.p2ecommerce,
            p2media: planInfo.p2media,
            p2pricing: planInfo.p2pricing,
            p2promotion: planInfo.p2promotion,
            p2promotionAdjusted: planInfo.p2promotionAdjusted,
            p2sales: planInfo.p2sales,
            p2check: planInfo.p2check,
            baseapproval: planInfo.baseapproval,
            p2volsSum: planInfo.p2volsSum
        }
    });
}

export function deletePlan(planID) {
    const url = mineUrl + '/Plan';

    return request({
        url: url,
        method: 'delete',
        data: {
            id: planID
        }
    });
}

export function getMineApprovalList(
    PlanName,
    ApproveStatus,
    CreateUserID,
    PlanType,
    PlanCountry,
    CreateMonthB,
    CreateMonthE,
    LastModifiedB,
    LastModifiedE,
    PlanOwnerUser,
    pageIndex,
    pageSize
) {
    const url =
        mineUrl +
        `/MineApprovalList?PlanName=${PlanName}&ApproveStatus=${ApproveStatus}&CreateUserID=${CreateUserID}&PlanType=${PlanType}&PlanCountry=${PlanCountry}&CreateMonthB=${CreateMonthB}&CreateMonthE=${CreateMonthE}&LastModifiedB=${LastModifiedB}&LastModifiedE=${LastModifiedE}&PlanOwnerUser=${PlanOwnerUser}&pageIndex=${pageIndex}&pageSize=${pageSize}`;

    return request({
        url: url,
        method: 'get'
    });
}

export function getApproval(planID) {
    const url = mineUrl + `/ApprovalHistory?planId=${planID}`;

    return request({
        url: url,
        method: 'get'
    });
}

export function postApproval(submitData) {
    const url = mineUrl + '/Approval';

    return request({
        url: url,
        method: 'post',
        data: {
            planID: submitData.planID,
            roleID: submitData.roleID,
            approvalUserID: submitData.approvalUserID,
            approvalStatus: submitData.approvalStatus,
            approvalComments: submitData.approvalComments,
            fileID: submitData.fileID,
            createUserID: submitData.createUserID,
            loadDecision: submitData.loadDecision
        }
    });
}

export function getRunrate(data) {
    const url = mineUrl + '/Runrate';

    return request({
        url: url,
        method: 'post',
        data: data
    });
}



// WEBPACK FOOTER //
// ./src/api/mine.js